import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {DialogService, UnsavedChangeDetector} from '@rbaip/ui-component';
import {Asset, BudgetInfo} from '../../shared/domain/item';
import {ItemSummaryItemService} from '../../shared/asset/item-summary-item.service';
import {AssetControlGroupBudgetsComponent} from '../../asset-package/asset-control-group-budgets/asset-control-group-budgets.component';
import {AssetPackageDto} from '../../shared/domain/asset-package';
import {getCurrencyCodeAndSymbol} from '../../shared/currencyUtil';

@Component({
  selector: 'lib-item-summary-asset-services',
  templateUrl: './asset-services.component.html',
  styleUrls: ['./asset-services.component.scss']
})
export class AssetServicesComponent extends UnsavedChangeDetector implements OnInit, OnChanges {

  @Input() asset: Asset;
  @Input() assetControlGroup: AssetPackageDto;
  @Input() editEnabled: boolean;
  @Input() itemId: number;
  @Input() editAssetFromPricing: boolean;
  @Input() itemService: ItemSummaryItemService;
  @Output() editModeChanged = new EventEmitter<boolean>();
  oldRnr: number;
  oldHaluling: number;
  oldRnrRollup: number;
  oldHaulingRollup: number;

  budgetInfo: BudgetInfo;
  isEditable: boolean;
  validNumericValue: string;
  constructor(private dialog: MatDialog,
              private dialogService: DialogService) {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.loadBudgetInfo();
      if(this.budgetInfo) {
        this.oldRnr = this.budgetInfo.oldRnrBudget;
        this.oldRnrRollup = this.budgetInfo.rnrRollup;
        this.oldHaluling = this.budgetInfo.oldHaulingBudget;
        this.oldHaulingRollup = this.budgetInfo.haulingRollup;

      }
    }
  }

  private loadBudgetInfo(): void {
    if (this.asset && this.assetControlGroup) {
      this.budgetInfo = BudgetInfo.getBudgetFromAssetAndAssetPackage(this.asset, this.assetControlGroup);
    }
  }

  setEditBudgets() {
    if ( this.budgetInfo ) {
      this.toggleEditMode();
    }
  }

  public isRnrBudgetValid(): boolean {
    if (this.budgetInfo.assetPackageRnRNotToExceed && this.budgetInfo.assetPackageRnRNotToExceed > 0) {
      return  this.budgetInfo.rnrRollup  >  this.budgetInfo.rnrNotToExceed;
    } else { return false; }
  }

  public isHaulingBudgetValid(): boolean {
    if (this.budgetInfo.assetPackageHaulingNotToExceed && this.budgetInfo.assetPackageHaulingNotToExceed > 0) {
      return this.budgetInfo.haulingRollup >  this.budgetInfo.haulingNotToExceed;
    } else { return false; }
  }

  cancel() {
    if ( this.budgetInfo ) {
      this.budgetInfo.assetRnrBudget = this.oldRnr;
      this.budgetInfo.assetHaulingBudget = this.oldHaluling;
      this.budgetInfo.rnrRollup = this.oldRnrRollup;
      this.budgetInfo.haulingRollup = this.oldHaulingRollup;
      this.budgetInfo.oldRnrBudget= this.oldRnr;
      this.budgetInfo.oldHaulingBudget=this.oldHaluling;
      this.validNumericValue=null;
      this.toggleEditMode();
    }
  }

  public calculateCommittedValue(valueType: String ){
    if(this.budgetInfo){
      if(valueType === 'rnr') {
        this.budgetInfo.rnrRollup = (this.budgetInfo.rnrRollup - this.budgetInfo.oldRnrBudget);
        this.budgetInfo.rnrRollup += this.budgetInfo.assetRnrBudget;
        this.budgetInfo.oldRnrBudget = this.budgetInfo.assetRnrBudget;
      }
      else {
        this.budgetInfo.haulingRollup = (this.budgetInfo.haulingRollup - this.budgetInfo.oldHaulingBudget);
        this.budgetInfo.haulingRollup += this.budgetInfo.assetHaulingBudget;
        this.budgetInfo.oldHaulingBudget = this.budgetInfo.assetHaulingBudget;
      }
    }
  }

  public editNotToExceedBudget(): void {
    this.dialog.open(AssetControlGroupBudgetsComponent, {
      panelClass: 'mat-panel--default',
      data: {
        assetControlGroupId: this.assetControlGroup.acgId,
        assetsRnrBudget: this.budgetInfo.rnrRollup,
        assetsHaulingBudget: this.budgetInfo.haulingRollup,
        rnrBudgetLimit: this.budgetInfo.rnrNotToExceed,
        haulingBudgetLimit: this.budgetInfo.haulingNotToExceed,
        opportunityCurrency: this.budgetInfo.opportunityCurrency
      },
      disableClose: true
    }).afterClosed().subscribe(assetControlGroup => {
      if (assetControlGroup) {
        this.budgetInfo.rnrNotToExceed = assetControlGroup.rnrBudgetLimit;
        this.budgetInfo.haulingNotToExceed = assetControlGroup.haulingBudgetLimit;
      }
    });
  }

  public saveAssetBudgets(): void {
    this.dialogService.showProgress();
    this.itemService.saveAssetBudget(this.itemId, this.budgetInfo.assetRnrBudget, this.budgetInfo.assetHaulingBudget)
      .subscribe( response => {
        this.dialogService.hideProgress();
        if (response) {
          this.budgetInfo = response;
          this.budgetInfo.isEditable = true;
          this.toggleEditMode();
        }
      });
  }

  hasChanges(): boolean {
    return this.budgetInfo.isEditable;
  }

  private toggleEditMode(): void {
    this.budgetInfo.isEditable = !this.budgetInfo.isEditable;
    this.broadcastEditModeChanged(this.budgetInfo.isEditable);
  }

  private broadcastEditModeChanged(isOnEditMode: boolean): void {
    this.editModeChanged.emit(isOnEditMode);
  }

  /**
   * This method will prevent the decimal numbers
   * @param event
   */
  public preventDecimalValue(event, ngModel) {
    this.validNumericValue = (event.key === '.') ? ngModel : null;
    if (event.key === '.') {
      event.preventDefault();
    }
  }

  public getCurrencyPlaceHolder(): string {
    return getCurrencyCodeAndSymbol(this.budgetInfo?.opportunityCurrency);
  }

  public isCurrencyPrefixVisible(theValue: any): boolean {
    return theValue != null && theValue !== '';
  }

}
